(() => {
  function mount() {
    const form = document.getElementById('ARMMiniAvailabilityForm');
    const details = document.getElementById('arm-mini-availability-enquiry');
    const button = document.querySelector('[data-arm-check-availability]');
    if (!form || !details || !button || button.dataset.ready) return;
    const state = document.querySelector('[data-arm-availability]');
    button.hidden = !!state && state.classList.contains('arm-availability--stock');
    button.dataset.ready = 'true';
    button.addEventListener('click', () => {
      details.open = true;
      const quantity = document.querySelector('#ARMProductForm input[name="quantity"], #ARMTrio6ProductForm input[name="quantity"]');
      const target = document.getElementById('arm-availability-quantity');
      if (quantity && target) target.value = quantity.value;
      details.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'nearest' });
      const name = document.getElementById('arm-availability-name');
      if (name) name.focus({ preventScroll: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();

